import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'reactstrap';

const Home = () => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <section className="section nft-hero" id="hero" style={{ paddingTop: "130px", paddingBottom: "50px" }}>
                <div className="bg-overlay bg-soft-warning"></div>
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8} sm={10}>
                            <div className="text-center">
                                <h2 className="display-6 fw-medium mb-4 lh-base">
                                    {t('t-mobile-app')}
                                </h2>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}

export default Home;